import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { forkJoin } from 'rxjs';
import { HtsNumberModel } from '@data-layer/models/common';
import { CodeRepository } from '@data-layer/repositories';

import { HTS_MASK } from '@helpers/custom-validator';
import { InvoiceModel } from '@data-layer/models/entry-summaries';
import { take } from 'rxjs/operators';

@Component({
  selector: 'isf-hts-details',
  templateUrl: './isf-hts-details.component.html',
  styleUrls: ['./isf-hts-details.component.scss'],
})
export class IsfHtsDetailsComponent implements OnInit, OnChanges {
  @Input() public invoiceEntity: InvoiceModel;
  @Input() public sequence: number;
  @Input() public showHtsDescription: boolean;

  public HTS_MASK = HTS_MASK;

  private htsList: HtsNumberModel[] = [];

  constructor(private codeRepository: CodeRepository) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.showHtsDescription && changes.invoiceEntity && this.invoiceEntity.lines) {
      this.getHtsList();
    }
  }

  public description(htsCode: string): string {
    const searchedItem = this.htsList.filter((hts) => !!hts).find((item) => item.number.toString().startsWith(htsCode.toString()));
    return searchedItem ? searchedItem.description.trim() : '';
  }

  private getHtsList() {
    forkJoin(this.invoiceEntity.lines.map((lineItem) => this.codeRepository.searchHts(lineItem.htsNumber.toString())))
      .pipe(take(1))
      .subscribe((htsList) => {
        this.htsList = htsList.map((items) => items[0]);
      });
  }
}
